import React, { useState } from "react";
import Loader from "react-loader-spinner";
import { InformationTileProps } from "./InformationTile.types";
import {
  Container,
  ContentContainer,
  Spinner,
  HoverItem,
  HoverTitle,
  HoverValue,
  Title,
  Value,
} from "./InformationTile.styles";

export const InformationTile: React.FC<InformationTileProps> = ({
  height,
  width,
  title,
  value,
  hoverStateData,
  hoverTitle,
  hoverValue,
  hoverValueType,
  isLoading,
}) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <Container
      height={height}
      width={width}
      isHovered={isHovered}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isLoading ? (
        <Spinner>
          <Loader type="Oval" color="#00BFFF" height={40} width={40} />
        </Spinner>
      ) : (
        <ContentContainer hoverStateData={hoverStateData} isHovered={isHovered}>
          {hoverStateData && isHovered ? (
            <>
              {!hoverStateData.length ? (
                <HoverItem>
                  <HoverValue>No data for time period</HoverValue>
                </HoverItem>
              ) : (
                hoverStateData.map((item: any, idx: number) => (
                  <HoverItem key={idx}>
                    <HoverTitle>{item[hoverTitle]}</HoverTitle>
                    <HoverValue>
                      {hoverValueType === "percent"
                        ? Math.round(item[hoverValue] * 100) + "%"
                        : hoverValueType === "dollar"
                        ? "$" + Math.round(item[hoverValue]).toLocaleString()
                        : item[hoverValue]}
                    </HoverValue>
                  </HoverItem>
                ))
              )}
            </>
          ) : (
            <>
              <Title>{title}</Title>
              <Value>{value}</Value>
            </>
          )}
        </ContentContainer>
      )}
    </Container>
  );
};
